import { Component, Input, OnInit } from '@angular/core';
import { CodeModel } from '@ngstack/code-editor';
import { size } from 'lodash';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-dev-tools',
  templateUrl: './dev-tools.component.html',
  styleUrls: ['./dev-tools.component.scss'],
})
export class DevToolsComponent implements OnInit {
  editorOptions = { theme: 'vs-dark', language: 'json', fontSize: 20 };
  codeTbre: string = '';
  codeDs: string = '';
  tbreKEY;
  tbreKEYParam;
  dsKEY;
  dsKEYParam;
  urlBackend;
  blink = false;
  constructor(private generalService: GeneralService) {}

  ngOnInit(): void {
    this.urlBackend = 'https://backend-uniges.pmc.tn/api/';
  }
  searchTable() {
    this.codeTbre = 'En cours';

    const backendUrl = this.generalService.api;
    this.generalService.api = this.urlBackend;
    console.log(this.generalService.api);

    this.generalService
      .rechercheTable2(this.tbreKEY, this.tbreKEYParam)
      .subscribe(
        (res) => {
          this.generalService.api = backendUrl;
          this.codeTbre = JSON.stringify(res, null, 4);
        },
        (err) => {
          this.generalService.api = backendUrl;
          this.codeTbre = JSON.stringify(err, null, 4);
        }
      );
  }
  ds() {
    this.codeDs = 'En cours';
    const backendUrl = this.generalService.api;
    this.generalService.api = this.urlBackend;

    this.generalService.getDS(this.dsKEY, this.dsKEYParam).subscribe(
      (res) => {
        this.codeDs = JSON.stringify(res, null, 4);
        this.generalService.api = backendUrl;

        // JSON.stringify(res)
      },
      (err) => {
        this.generalService.api = backendUrl;

        this.codeDs = JSON.stringify(err, null, 4);
      }
    );
  }
  updateSize(val) {
    this.editorOptions.fontSize += val;
    this.blink = true;
    setTimeout(() => {
      this.blink = false;
    }, 50);
  }
  shearchBoth() {
    this.ds();
    this.searchTable();
  }
}
